import userInfo from 'hub-http/userInfo';
export const getUserInfo = () => userInfo().then(info => ({
  email: info.user.email
}));